module.exports = __webpack_public_path__ + "img/binds-end-message-logo.0cad22a4.svg";